import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCompany } from 'contexts/CompanyContext';
import { ROUTES } from 'constants/routes';
import { Loader2 } from 'lucide-react';

/**
 * CompanyHomeRedirect
 *
 * This component handles the default home route by redirecting users to:
 * 1. The selected company's dashboard if a company is selected
 * 2. The first company's dashboard if no selection but companies exist
 * 3. The companies decision hub if user has no companies
 */
export default function CompanyHomeRedirect() {
  const navigate = useNavigate();
  const { selectedCompany, companies, isLoading, hasCompanies } = useCompany();

  useEffect(() => {
    if (isLoading) return;

    if (selectedCompany?.id) {
      // User has a selected company - go to its dashboard
      navigate(ROUTES.COMPANY_DASHBOARD(selectedCompany.id), { replace: true });
    } else if (hasCompanies && companies.length > 0) {
      const firstCompany = companies[0];
      // No selection but has companies - go to first company's dashboard
      navigate(ROUTES.COMPANY_DASHBOARD(firstCompany.id), { replace: true });
    } else {
      // No companies - go to the decision hub
      navigate(ROUTES.EMPRESAS, { replace: true });
    }
  }, [isLoading, selectedCompany, companies, hasCompanies, navigate]);

  // Show loading spinner while determining where to redirect
  return (
    <div className="flex h-screen w-full items-center justify-center bg-neutral-50 dark:bg-neutral-900">
      <div className="flex flex-col items-center gap-4">
        <Loader2 className="h-8 w-8 animate-spin text-primary-500" />
        <p className="text-sm text-neutral-500 dark:text-neutral-400">
          Loading...
        </p>
      </div>
    </div>
  );
}
